var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.95068 7.8684L5.62793 10.0994C5.8047 10.2468 6.02751 10.3274 6.25762 10.3274H17.3486C17.5788 10.3274 17.8016 10.2468 17.9783 10.0994L20.6556 7.8684M6.39331 13.77H6.40314M17.213 13.77H17.2228M8.02673 4.42578H15.5796C16.2855 4.42578 16.9374 4.80405 17.2875 5.41698L20.1372 10.4038C20.4769 10.9983 20.6556 11.6711 20.6556 12.3559V18.1963C20.6556 18.7395 20.2152 19.1799 19.672 19.1799H18.6884C18.1451 19.1799 17.7048 18.7395 17.7048 18.1963V17.2127H5.9015V18.1963C5.9015 18.7395 5.46112 19.1799 4.9179 19.1799H3.93429C3.39106 19.1799 2.95068 18.7395 2.95068 18.1963V12.3559C2.95068 11.6711 3.12937 10.9983 3.46907 10.4038L6.31871 5.41698C6.66895 4.80405 7.32078 4.42578 8.02673 4.42578ZM6.88511 13.77C6.88511 14.0416 6.66492 14.2618 6.39331 14.2618C6.12169 14.2618 5.9015 14.0416 5.9015 13.77C5.9015 13.4985 6.12169 13.2782 6.39331 13.2782C6.66492 13.2782 6.88511 13.4985 6.88511 13.77ZM17.7048 13.77C17.7048 14.0416 17.4846 14.2618 17.213 14.2618C16.9414 14.2618 16.7212 14.0416 16.7212 13.77C16.7212 13.4985 16.9414 13.2782 17.213 13.2782C17.4846 13.2782 17.7048 13.4985 17.7048 13.77Z",
    stroke: "#9393B0",
    strokeWidth: 1.96721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSvgrepocom);
export default __webpack_public_path__ + "static/media/car_svgrepo.com.c6c16343b4fe82dae63c2081700dcce6.svg";
export { ForwardRef as ReactComponent };